var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var UNSET_STR = 'Unset';
var getColorAttr = function (colorEntry) {
    var defaultAttr = {
        id: 'color-unset',
        name: UNSET_STR,
        hex: '#ddd'
    };
    return __assign(__assign({}, defaultAttr), (colorEntry
        ? __assign({ id: colorEntry.sys.id }, colorEntry) : {}));
};
var getStorageAttr = function (storageEntry) {
    var defaultAttr = {
        ref: 'Unset',
        id: 'storage-unset',
        size: 128,
        unit: 'GB'
    };
    return __assign(__assign({}, defaultAttr), (storageEntry
        ? __assign({ id: storageEntry.sys.id }, storageEntry) : {}));
};
var getConditionAttr = function (gradeEntry, phoneType) {
    if (phoneType === void 0) { phoneType = ''; }
    if (phoneType !== 'preowned')
        return null;
    var defaultAttr = {
        id: 'condition-unset',
        condition: UNSET_STR
    };
    return __assign(__assign({}, defaultAttr), (gradeEntry
        ? {
            id: gradeEntry.sys.id,
            condition: gradeEntry.value
        }
        : {}));
};
/**
 * Takes in the full device object returned from Contentful and returns an array of devices summarized by sku, color, storage and condition.
 * Skus for regular phones missing storage or color options are not included in the returned array.
 * Skus for certified pre-owned phones missing storage, color or condition options are not included in the returned array.
 * @param {Array} device
 * @returns {Array} => [{sku:string, color:{}, storage:{}, condition:{}}]
 */
var getAllPhoneDetails = function (devices) {
    var deviceDetails = devices === null || devices === void 0 ? void 0 : devices.map(function (phone) {
        return {
            sku: phone.productCode,
            color: getColorAttr(phone.colour),
            storage: getStorageAttr(phone.storage),
            condition: getConditionAttr(phone.grade, phone === null || phone === void 0 ? void 0 : phone.type),
            type: phone.type
        };
    }).filter(function (x) { return x; });
    return deviceDetails;
};
export default getAllPhoneDetails;
